import { Component, OnInit, Output, EventEmitter, inject, Input } from '@angular/core';
import { FormControl, FormGroup, FormsModule, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { PasswordResetComponent } from '../password-reset/password-reset.component';
import { AuthService } from '../../../../services/auth/auth.service';
import { MfaVerificationComponent } from "../mfa-verification/mfa-verification.component";
import { ForcePasswordResetComponent } from "../force-password-reset/force-password-reset.component";
import { TokenService } from '../../../../services/auth/token.service';
import { LoginCoordinationService } from '../../../../services/auth/login-coordination.service';
import { TermsAndConditionsComponent } from "../terms-and-conditions/terms-and-conditions.component";
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
//import { AuditService } from '../../../../services/auth/audit.service';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, CommonModule, PasswordResetComponent, ReactiveFormsModule, MfaVerificationComponent, ForcePasswordResetComponent, TermsAndConditionsComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {

  @Input() termsAccepted: boolean = false;

  @Output() emitterOpenTerms = new EventEmitter<boolean>();
  @Output() token = new EventEmitter<string>();

  renderSSO: boolean = false;

  /*@Output() username = new EventEmitter<string>();
  @Output() session = new EventEmitter<string>();*/

  username: string = '';
  session: string = '';

  router = inject(Router)
  showPassword = false;
  password: string = "";
  isLoading: boolean = false;
  isPasswordResetOpen: boolean = false;
  isMfaVerificationOpen: boolean = false;
  isForcePwdResetOpen: boolean = false;
  pendingLoginData: any = null;
  isTermsOpen: boolean = false;
  isTermsAccepted: boolean = false;

  company!: string;
  redirectUrl?: string;
  isSSOLoading: boolean = false;

  errorMessage: string = '';

  loginForm = new FormGroup({
    email: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required)
  })
  isInvalidCredentials: boolean = false;

  constructor (private route: ActivatedRoute, private authService: AuthService, private tokenService: TokenService, private loginCoordinationService: LoginCoordinationService/*, private auditService: AuditService*/) { }

  ngOnInit (): void {
    //console.log("Password reset open? ", this.isPasswordResetOpen)
    this.loginCoordinationService.termsAccepted$.subscribe((accepted: boolean) => {
      this.onTermsAccepted(accepted);
    });

    this.company = this.route.snapshot.paramMap.get('company')!;

    if (this.company) {
      this.renderSSO = true;
      this.isSSOLoading = true;
      this.authService.ssoStart(this.company).subscribe({
        next: (res) => {
          sessionStorage.setItem("cSlug", this.company);
          this.redirectUrl = res.redirectUrl;
          this.isSSOLoading = false;
        },
        error: err => {
          alert('SSO Start failed');
          this.redirectUrl = undefined;
          this.router.navigate(['/login']);
        }
      });

    }


    const code = new URLSearchParams(window.location.search).get('code');
    const state = new URLSearchParams(window.location.search).get('state');

    if (code && state) {
      this.authService.loginSSO(code, state).subscribe({
        next: (data) => {
          if (data.accessToken) {
            sessionStorage.setItem('access_token', data.accessToken);
            sessionStorage.setItem('username', data.username);
            const companyId = data.companyId.toString();
            sessionStorage.setItem('companyId', companyId);
            sessionStorage.setItem('setup', JSON.stringify({
              companyName: data.companyName || '',
              companyRole: data.companyRole || '',
              role: data.role || '',
              regionsIds: data.regionsIds || []
            }));

            if (!data.hasAcceptedTerms) {
              // open terms and conditions if the user hasn't accepted yet
              this.pendingLoginData = data;
              this.isTermsOpen = true;
              return;
            }
            this.tokenService.setToken(data.accessToken);
            //this.auditService.logLogin();
            this.isLoading = false;
            this.router.navigate(['/dashboard']);
          }
        },
        error: err => {
          alert('Login failed');
          console.error(err);
          this.router.navigate(['/login']);
        }
      });
    }
  }

  togglePassword () {
    this.showPassword = !this.showPassword;
  }

  login () {
    sessionStorage.removeItem("cSlug");
    const email = this.loginForm.get('email')?.value?.trim() ?? '';
    const password = this.loginForm.get('password')?.value?.trim() ?? '';

    this.isLoading = true;

    if (!email || !password) {
      console.log("Please fill in all fields.");
      this.errorMessage = 'Si prega di compilare tutti i campi.';
      this.isInvalidCredentials = true;
      this.isLoading = false;
      return; // Stop execution if fields are empty
    }

    this.authService.login(
      email,
      password
    ).subscribe(async (data) => {
      if (data) {

        this.isInvalidCredentials = false;
        sessionStorage.setItem('username', data.username);


        if (data.challengeName === 'NEW_PASSWORD_REQUIRED') {
          sessionStorage.setItem('username', data.username);
          this.username = data.username;
          this.session = data.session ?? '';
          //this.showForcePwdChange.emit(true);
          this.isForcePwdResetOpen = true;
          return;
        }

        if (data.challengeName === 'EMAIL_OTP') {
          sessionStorage.setItem('username', data.username);
          this.username = data.username;
          this.session = data.session ?? '';
          this.isMfaVerificationOpen = true;
          return;
        }

        if (data.accessToken) {
          sessionStorage.setItem('access_token', data.accessToken);
          sessionStorage.setItem('username', data.username);
          const companyId = data.companyId.toString();
          sessionStorage.setItem('companyId', companyId);
          sessionStorage.setItem('setup', JSON.stringify({
            companyName: data.companyName || '',
            companyRole: data.companyRole || '',
            role: data.role || '',
            regionsIds: data.regionsIds || []
          }));

          if (!data.hasAcceptedTerms) {
            // open terms and conditions if the user hasn't accepted yet
            this.pendingLoginData = data;
            this.isTermsOpen = true;
            //this.emitterOpenTerms.emit(true);
            return;
          }
          this.tokenService.setToken(data.accessToken);
          //this.auditService.logLogin();
          this.isLoading = false;
          this.router.navigate(['/dashboard']);
        }
      } else {
        this.errorMessage = 'Nome Utente e/o password non corretti.'
        this.isInvalidCredentials = true;
        this.isLoading = false;
      }
    }, error => {
      this.errorMessage = 'Nome Utente e/o password non corretti.'
      this.isInvalidCredentials = true;
      this.isLoading = false;
    });

  }

  loginWithMicrosoft () {

    /* const redirectUri = encodeURIComponent(environment.COGNITO_REDIRECT_URI)
     const clientId = environment.COGNITO_CLIENT_ID;
     const issuer = environment.COGNITO_ISSUER;
     const authUrl = `${issuer}/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&identity_provider=MicrosoftLogin&scope=openid+profile+email`;
     window.location.href = authUrl;*/

    if (this.redirectUrl) {
      window.location.href = this.redirectUrl;
    }
  }

  onTermsAccepted (accepted: boolean) {
    // Resume with previously saved login data
    if (this.pendingLoginData) {
      this.pendingLoginData.hasAcceptedTerms = accepted;
      this.handleLoginChallenge(this.pendingLoginData);
    }
  }

  handlePendingLoginData (data: any) {
    this.pendingLoginData = data;
  }

  handleLoginChallenge (data: any) {
    /*if (data.challengeName === 'NEW_PASSWORD_REQUIRED') {
      sessionStorage.setItem('username', data.username);
      this.username = data.username;
      this.session = data.session ?? '';
      this.isForcePwdResetOpen = true;
      return;
    }

    if (data.challengeName === 'EMAIL_OTP') {
      sessionStorage.setItem('username', data.username);
      this.username = data.username;
      this.session = data.session ?? '';
      this.isMfaVerificationOpen = true;
      return;
    }*/

    if (data.token) {
      sessionStorage.setItem('access_token', data.token);
      sessionStorage.setItem('username', data.username);
      sessionStorage.setItem('companyId', data.companyId.toString());
      sessionStorage.setItem('setup', JSON.stringify({
        companyName: data.companyName || '',
        companyRole: data.companyRole || '',
        role: data.role || '',
        regionsIds: data.regionsIds || []
      }));
      this.tokenService.setToken(data.token);
      //this.auditService.logLogin();
      this.isLoading = false;
      this.router.navigate(['/dashboard']);
    }
  }

  handleOpenTerms (shouldOpen: boolean) {
    this.isTermsOpen = shouldOpen;
  }

  handleTermsAccepted (value: boolean) {
    this.isTermsAccepted = value;
    this.loginCoordinationService.notifyTermsAccepted(value);
    //this.canUserAccessPlatform=value;
    //this.canAccessEvent.emit(this.canUserAccessPlatform); 
  }

  resetPassword () {
    this.isPasswordResetOpen = true;
  }

  handlePasswordResetStatus (shouldClose: boolean) {
    this.isPasswordResetOpen = shouldClose;
  }

  continueAndOpenTerms () {
    this.emitterOpenTerms.emit(true);
  }
}
